import { createDomain } from 'effector'
import i18next from 'i18next'
import { LocaleEnum } from '~/shared/config/enums'

export const domain = createDomain('lib.i18n')

export const localeChangeFx = domain.createEffect<{ locale: LocaleEnum }, void>(
  {
    handler({ locale }) {
      i18next.changeLanguage(locale)
    },
  },
)
